import script from "./withAuthLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./withAuthLayout.vue?vue&type=script&setup=true&lang=js"

import "./withAuthLayout.vue?vue&type=style&index=0&id=bb148242&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb148242"]])

export default __exports__